import type { PurchaseOrder } from "@shared/types";

/**
 * Creates an interleaved sequence from fitted label URLs and packing slip URLs.
 * For each position i, the output is: [label[i], slip[i]] (items skipped when absent).
 */
export const createInterleavedSequence = (fitted: string[], slips: string[]): string[] => {
  const sequence: string[] = [];
  const maxLen = Math.max(fitted.length, slips.length);
  for (let i = 0; i < maxLen; i++) {
    const fittedItem = fitted[i];
    const slipItem = slips[i];
    if (fittedItem) {
      sequence.push(fittedItem);
    }
    if (slipItem) {
      sequence.push(slipItem);
    }
  }
  return sequence;
};

/**
 * Creates a Map from purchaseOrderId to sequential index starting from `offset`.
 */
export const createOrderIndexMap = (orders: PurchaseOrder[], offset: number = 0): Map<string, number> => {
  const orderIndexMap = new Map<string, number>();
  orders.forEach((order, index) => {
    orderIndexMap.set(order.purchaseOrderId, offset + index);
  });
  return orderIndexMap;
};
